/**
 * workflow-core
 *
 * Copyright (c) Ballerine
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
import { inheritsLoose as _inheritsLoose } from '../../_virtual/_rollupPluginBabelHelpers.js';
import get from 'lodash.get';
import isEmpty from 'lodash.isempty';
import { z } from 'zod';
import { DataValueNotFoundError, ValidationFailedError } from '../errors.js';
import { BaseOperator } from './helpers.js';
import { IdvCheckSchema } from './schemas.js';

var IDV_DECLINED_STATUS = 'declined';
var createDataSchema = function createDataSchema(childWorkflowName) {
  return z.object({
    childWorkflows: z.record(z.string(), z.record(z.string(), z.any())).refine(function (childWorkflows) {
      return !!childWorkflows[childWorkflowName];
    }, {
      message: "childWorkflows." + childWorkflowName + " not found",
      path: ["childWorkflows." + childWorkflowName]
    }).refine(function (childWorkflows) {
      return Object.keys(childWorkflows[childWorkflowName] || {}).length > 0;
    }, {
      message: "childWorkflows." + childWorkflowName + " is empty",
      path: ["childWorkflows." + childWorkflowName]
    })
  });
};
var IdvCheck = /*#__PURE__*/function (_BaseOperator) {
  function IdvCheck() {
    return _BaseOperator.call(this, {
      operator: 'IDV_CHECK',
      conditionValueSchema: IdvCheckSchema
    }) || this;
  }
  _inheritsLoose(IdvCheck, _BaseOperator);
  var _proto = IdvCheck.prototype;
  _proto.extractValue = function extractValue(data, rule) {
    var idvRule = rule;
    var childWorkflowName = idvRule.value.childWorkflowName;
    var dataSchema = createDataSchema(childWorkflowName);
    var result = dataSchema.safeParse(data);
    if (!result.success) {
      var _error$errors$;
      var error = result.error;
      var errorPath = (_error$errors$ = error.errors[0]) == null ? void 0 : _error$errors$.path.join('.');
      if (errorPath != null && errorPath.includes(childWorkflowName)) {
        throw new DataValueNotFoundError("childWorkflows." + childWorkflowName);
      }
      throw new ValidationFailedError('extract', 'parsing failed', error);
    }
    var childWorkflows = result.data.childWorkflows[childWorkflowName];
    var childWorkflowKeys = Object.keys(childWorkflows || {});
    var decisions = childWorkflowKeys.map(function (workflowId) {
      return get(childWorkflows, workflowId + ".result.vendorResult.decision.status");
    }).filter(function (status) {
      return typeof status === 'string' && status !== '';
    });
    if (isEmpty(decisions)) {
      throw new Error('No decisions found');
    }
    return decisions;
  };
  _proto.evaluate = function evaluate(dataValue, conditionValue) {
    var expectedStatus = IDV_DECLINED_STATUS;
    return dataValue.some(function (status) {
      return status.toLowerCase() === expectedStatus;
    });
  };
  return IdvCheck;
}(BaseOperator);
var IDV_CHECK = new IdvCheck();

export { IDV_CHECK };
//# sourceMappingURL=idv-check.js.map
